import navigateOnQuerySyncPush from './navigateOnQuerySyncPush';
import navigateOnQuerySyncReplace from './navigateOnQuerySyncReplace';
import { combineEpicsWithNames } from '../../../utils/helpers';

export default combineEpicsWithNames({
  navigateOnQuerySyncPush,
  navigateOnQuerySyncReplace
});